import React, { FC, PropsWithChildren, ReactElement } from 'react';
import { Flex, Tooltip, Typography } from '@duxton-web/ui';
import { TextProps } from '@duxton-web/ui/es/typography/Text';

interface OwnProps {
  key?: string;
  tooltip?: string;
  showTooltip?: boolean;
  showTooltipWithChildren?: boolean;
}

type CustomTextProps = OwnProps & TextProps;

export const Text: FC<PropsWithChildren<CustomTextProps>> = ({
  className,
  children,
  tooltip,
  showTooltip = true,
  showTooltipWithChildren = true,
  ...others
}) => {
  function renderTextContent(): ReactElement {
    return (
      <Typography.Text
        className={`grab-x__typography-text ${className || ''}`}
        {...others}
      >
        {children}
      </Typography.Text>
    );
  }

  function renderText(): ReactElement {
    if (!showTooltip) return renderTextContent();

    return (
      <Tooltip
        title={
          !tooltip ? (
            children
          ) : (
            <Flex vertical gap={16}>
              {showTooltipWithChildren && <div>{children}</div>}
              <div>{tooltip}</div>
            </Flex>
          )
        }
        placement="leftBottom"
      >
        {renderTextContent()}
      </Tooltip>
    );
  }

  return renderText();
};
